webpackJsonp([206907524185279],{

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _contentblock = __webpack_require__(9);
	
	var _contentblock2 = _interopRequireDefault(_contentblock);
	
	var _sidebar = __webpack_require__(18);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _infobox = __webpack_require__(23);
	
	var _infobox2 = _interopRequireDefault(_infobox);
	
	var _dexa = __webpack_require__(161);
	
	var _dexa2 = _interopRequireDefault(_dexa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CtPage = function CtPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_page2.default, { headline: 'CT', image: _dexa2.default }),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom split' },
	      _react2.default.createElement(
	        'div',
	        { className: 'custom-container' },
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen zu Hause:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die Untersuchungsregion muss frei von Kleidung und Schmuck sein.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Bringen Sie Ihre ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Vorbefunde'
	              ),
	              ' mit (OP-Berichte, R\xF6ntgenbilder etc.).'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen in der Ordination:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'F\xFCllen Sie in der Ordination das ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Anamneseblatt'
	              ),
	              ' aus.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Teilen Sie uns eine ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'eventuelle Schwangerschaft'
	              ),
	              ' unverz\xFCglich mit.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Liegen Sie w\xE4hrend der Untersuchung ruhig. Sie ist generell von kurzer Dauer, abh\xE4ngig von der zu untersuchenden Region.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Im Bedarfsfall erfolgt eine Aufkl\xE4rung \xFCber ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Kontrastmittel'
	              ),
	              '.',
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Bei CT-Untersuchungen mit Kontrastmittel ist es wichtig, dass Sie uns unverz\xFCglich \xFCber eine eventuelle Schilddr\xFCsen- oder Diabeteserkrankung informieren und ob Ihre Nierenwerte im Normbereich sind.'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Befundsbesprechung:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Befundbesprechung'
	              ),
	              ' erfolgt beim \xFCberweisenden Arzt/\xC4rztin.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'aside',
	        { className: 'sidebar' },
	        _react2.default.createElement(_sidebar2.default, null),
	        _react2.default.createElement(_infobox2.default, { name: 'ct' })
	      )
	    )
	  );
	};
	
	exports.default = CtPage;
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dexa.dc4bdf51.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leistungen-ct-js-c9e8c972f5f475cffbc3.js